import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "profileDropdown",
    "profileTrigger",
    "mobileTrigger",
    "mobileDropdown",
    "mobileTriggerIconClose",
    "mobileTriggerIconOpen",
  ]

  connect() {
    this.closeDropdowns = this.closeDropdowns.bind(this)
    window.addEventListener("keydown", this.closeDropdowns)
  }

  toggleProfileDropdown() {
    if (this.profileDropdownTarget.classList.contains("hidden")) {
      this.profileDropdownTarget.classList.remove("hidden")
      this.profileDropdownTarget.classList.add("block")
    } else {
      this.profileTriggerTarget.blur()
      this.profileDropdownTarget.classList.add("hidden")
    }
  }

  toggleMobileDropdown() {
    if (this.mobileDropdownTarget.classList.contains("hidden")) {
      this.mobileDropdownTarget.classList.remove("hidden")
      this.mobileTriggerIconCloseTarget.classList.remove("hidden")
      this.mobileDropdownTarget.classList.add("block")
      this.mobileTriggerIconCloseTarget.classList.add("block")
      this.mobileTriggerIconOpenTarget.classList.add("hidden")
    } else {
      this.mobileDropdownTarget.classList.add("hidden")
      this.mobileTriggerIconCloseTarget.classList.add("hidden")
      this.mobileTriggerIconOpenTarget.classList.remove("hidden")
      this.mobileTriggerIconOpenTarget.classList.add("block")
      this.mobileTriggerIconOpenTarget.blur()
    }
  }

  closeDropdowns(event) {
    if (event.key === "Escape") {
      event.preventDefault()
      this.profileDropdownTarget.classList.add("hidden")
      this.profileTriggerTarget.blur()
      this.mobileDropdownTarget.classList.add("hidden")
      this.mobileTriggerIconCloseTarget.classList.add("hidden")
      this.mobileTriggerIconOpenTarget.classList.remove("hidden")
      this.mobileTriggerIconOpenTarget.classList.add("block")
      this.mobileTriggerIconOpenTarget.blur()
    }
  }

  disconnect() {
    window.removeEventListener("keydown", this.closeDropdowns)
  }
}
